import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const bookingDeleteAtom = createMutationAtomFactory(
  'trade.bookingDelete',
  (params: { id: string; forceUnlink?: boolean }) => ({
    tradeBookingDelete: {
      __args: {
        id: params.id,
        forceUnlink: params.forceUnlink ?? false,
      },
      deleted: true,
      blockingLoads: {
        id: true,
        documentNumber: true,
      },
      unlinkableLoads: {
        id: true,
        documentNumber: true,
      },
    },
  }),
);
